import { Fragment } from 'react';

import useCompetitorListRegistrationForm from './UseCompetitorListRegistrationForm';

import PrimaryButton from '../../buttons/PrimaryButton';
import SecondaryButton from '../../buttons/SecondaryButton';
import Dropdown from '../../dropdowns/Dropdown';
import PopUpModal from '../../dialogs/PopUpModal';

import GroupPersonCoachesDropdown from '../../dropdowns/groupPersonCoachesDropdown/GroupPersonCoachesDropdown';

import Constants from '../../../utils/Constants';

import global from '../../GlobalStyle.module.css';

const CompetitorListRegistrationForm = ({ personId, personOrgGroupId, personOrgGroupQualificationStatus, groupObj, memberGroupObj,
  primaryButtonText = 'Save', secondaryButtonText = 'Back', disableValidation = false, onSecondaryButtonClicked,
  onFormCompletion }) => {
  const {
    isLoading,
    formState,
    errorState,
    optionsState,
    handleSubmit,
    onValueTextPairChanged
  } = useCompetitorListRegistrationForm(personId, personOrgGroupId, personOrgGroupQualificationStatus, groupObj, memberGroupObj, disableValidation, onFormCompletion);

  return (
    <Fragment>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Dropdown
              label={disableValidation === true ? 'Attendee Type' : 'Attendee Type*'}
              name="groupAttendeeTypeId"
              value={formState.groupAttendeeTypeId}
              error={errorState.groupAttendeeTypeId}
              message={errorState.groupAttendeeTypeId}
              areValuesIntegers={false}
              isLoading={optionsState.areOptionsLoaded !== true}
              options={optionsState.attendTypeOptions}
              onChange={(newValue, newValueLabel) => { onValueTextPairChanged(newValue, 'groupAttendeeTypeId', newValueLabel, 'groupAttendeeTypeName'); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Dropdown
              label={disableValidation === true ? 'Role' : 'Role*'}
              name="groupRoleTypeId"
              value={formState.groupRoleTypeId}
              error={errorState.groupRoleTypeId}
              message={errorState.groupRoleTypeId}
              areValuesIntegers={false}
              isLoading={optionsState.areOptionsLoaded !== true}
              options={optionsState.roleOptions}
              onChange={(newValue, newValueLabel) => { onValueTextPairChanged(newValue, 'groupRoleTypeId', newValueLabel, 'groupRoleTypeName'); }} />
          </div>
          {personId &&
            <div className="col-xs-12 col-sm-6 col-md-4">
              <GroupPersonCoachesDropdown
                label={disableValidation === true ? 'Personal Coach' : 'Personal Coach*'}
                name="personalCoachId"
                value={formState.personalCoachId}
                error={errorState.personalCoachId}
                message={errorState.personalCoachId}
                personId={personId}
                onChange={(newValue, newValueLabel) => { onValueTextPairChanged(newValue, 'personalCoachId', newValueLabel, 'personalCoachName'); }} />
            </div>
          }
          {disableValidation === true &&
            <div className="col-xs-12 col-sm-6 col-md-4">
              <Dropdown
                label={'Potential/Confirmed'}
                name="potentialOrConfirmedId"
                value={formState.potentialOrConfirmedId}
                error={errorState.potentialOrConfirmedId}
                message={errorState.potentialOrConfirmedId}
                areValuesIntegers={false}
                isLoading={optionsState.areOptionsLoaded !== true}
                options={optionsState.potentialOrConfirmedOptions}
                onChange={(newValue, newValueLabel) => { onValueTextPairChanged(newValue, 'potentialOrConfirmedId', newValueLabel, 'potentialOrConfirmedName'); }} />
            </div>
          }
        </div>
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
            <PrimaryButton type="submit">{primaryButtonText}</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onSecondaryButtonClicked}>{secondaryButtonText}</SecondaryButton>
            {errorState && errorState.errorOnSubmitAction
              && <p className={global.ErrorMessage}>{errorState.errorOnSubmitAction}</p>
            }
          </div>
        </div>
      </form>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={isLoading} />
    </Fragment>
  );
};

export default CompetitorListRegistrationForm;